import { Grid } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Spinner } from "../../molecules";

const useStyles = makeStyles(() => {
    return {
        wrapper: { height: "100vh", width: "100%" },
        loader: {
            height: "fit-content",
        },
    };
});

const FullScreenSpinner: React.FunctionComponent<{ localizedMessageKey?: string; noFade?: boolean }> = (props) => {
    const { localizedMessageKey, noFade } = props;
    const classes = useStyles();
    return (
        <Grid key="loader" container className={classes.wrapper} alignItems="center" alignContent="center">
            <Grid item className={classes.loader} xs={12}>
                <Spinner localizedMessageKey={localizedMessageKey || "spinner.initializing"} noFade={noFade} />
            </Grid>
        </Grid>
    );
};

export default FullScreenSpinner;
